import { NEWCPPREQUEST, DROPDOWNVALUES_URL } from "../../../constants";
import "./headerSection.scss";
import { CDBNavbar, CDBNavBrand } from 'cdbreact';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Menu } from 'primereact/menu';
import { useRef, useEffect, useState } from 'react';
import { ReportProblem } from '../../../pages/reportProblem/ReportProblem';
import { FeatureRequest } from '../../../pages/featureRequest/FeatureRequest';
import { Dialog } from 'primereact/dialog';
import axios from 'axios';
import Spinner from "../../shared/spinner.jsx";
import nameformat from './nameformat.jsx';
import { Avatar } from 'primereact/avatar';
import image from '../../../assets/pccpheader.svg';
import { Tooltip } from "primereact/tooltip";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";

export default function HeaderSection({ details }) {
  const menu = useRef(null);
  const items = [];
  const [showReportProblem, setShowReportProblem] = useState(false);
  const [showRequestFeature, setShowRequestFeature] = useState(false);
  const [issueTypesData, setIssueTypesData] = useState([]);
  const [featureTypesData, setFeatureTypesData] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const op = useRef(null);
  
  const getDropdownValues = async (tableName) => {
    let BASE_URL =  process.env.REACT_APP_API_URI;
    let url = BASE_URL + DROPDOWNVALUES_URL + "?tableName=" + tableName;
    const headers = {
      "Content-Type": "application/json",
    };

    const res = await new Promise((resolve, reject) => {
      try {
        setShowLoader(true);
        axios
          .get(url, { headers: headers, withCredentials: true })
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            resolve(err);
          });
      } catch (error) {
        reject(error);
      }
      finally{
        setShowLoader(false);
      }
    });
    if (res?.httpStatus?.toString() === "200") {
      if (tableName === "issue_types") {
        setIssueTypesData(res?.data?.codes);
      }

      if (tableName === "feature_types") {
        setFeatureTypesData(res?.data?.codes);
      }
    }
  }

  useEffect(() => {
    getDropdownValues("issue_types");
    getDropdownValues("feature_types");
  }, []);

  useEffect(() => {
    items.push({
      label: 'Report a problem',
      icon: 'reportProblem',
      command: () => {
        reportProblem(true);
      },
    });
    items.push({
      label: 'Feature Request',
      icon: 'requestFeature',
      command: () => {
        featureRequest(true);
      },
    });
  });

  const reportProblem = (val) => {
    setShowReportProblem(val);
  }


  const Callback = (val) => {
    setShowReportProblem(val);
    setShowRequestFeature(val);
  }

  const featureRequest = (val) => {
    setShowRequestFeature(val);
  }


  const popupMenuClickHandler = (e) => {
    e.preventDefault();
    menu.current?.toggle(e);
  };
  
  const handleSignOut = () => {
    setShowLoader(true);
    const logoutUrl =  process.env.REACT_APP_BASE_URI + "logout";
  
    const newTab = window.open(logoutUrl, "_blank");
  
    window.focus(); 
  
    if (newTab) {
      setTimeout(() => {
        if (!newTab.closed) {
          newTab.close(); 
        }
  
        window.location.reload(); 
      }, 2000);  
    }
  };

const confirmLogout = () => {
  confirmDialog({
    message: "Are you sure you want to log out?",
    header: "Logout Confirmation",
    icon: "pi pi-exclamation-triangle",
    accept: handleSignOut,
    reject: () => {},
    closable: false
  });
};

  return (
    <>
      <CDBNavbar>
        <img src={image}/>
        <div className="testimonial-slide">
          <div
            onClick={(e) => popupMenuClickHandler(e)}
            aria-controls="popup_menu"
            aria-haspopup
            style={{ cursor: 'pointer' }}
          >
            <i className="pi pi-ellipsis-v m-3" style={{ fontSize: '1.2em', color : "#3299FF" }} />
          </div>
          <Menu model={items} popup ref={menu} id="popup_menu" className="headerFeatures" />
                <OverlayPanel ref={op}>
                <b>{'Welcome,  ' + details.username}</b>
                </OverlayPanel>
                <Avatar label={nameformat(details.username !== null ? details.username : "")} shape="circle" className="avatarimg" size="large" onMouseEnter={(e) => op.current.toggle(e)} onMouseLeave={(e) => op.current.toggle(e)}/>
                <i  className="pi pi-sign-out logout-icon" data-pr-tooltip="Logout"
                 data-pr-position="bottom" onClick={confirmLogout} style={{ fontSize: "1.8rem", cursor: "pointer", margin: "10px", color:"#3299FF" }} ></i>
                <Tooltip target=".logout-icon" />
                <ConfirmDialog className="custom-confirm-dlg"/>
                </div>
      </CDBNavbar>
      <Dialog
        visible={showReportProblem}
        style={{ width: '40vw', borderRadius: '12px' }}
        onHide={() => reportProblem(false)}
        className="reportProblemDialog"
      >
        <ReportProblem issueTypes={issueTypesData} handleCallback={Callback} />
      </Dialog>
      <Dialog
        /* header="Report a problem" */
        visible={showRequestFeature}
        style={{ width: '40vw', borderRadius: '12px' }}
        onHide={() => featureRequest(false)}
        className="reportProblemDialog"
      >
        <FeatureRequest
           featureTypes={featureTypesData} handleCallback={Callback}
        />
      </Dialog>
      {showLoader && (
        <div className="divSpinner">
          <Spinner />
        </div>
      )}
    </>
  );
}
